import { SectionError } from "~/components/company/section-error";
import { type DocumentsResponse, DocumentsTab } from "~/components/company/tabs/documents-tab";
import {
	companyCanonicalUrl,
	companyFromMatches,
	companyNotFoundMeta,
	companySocialMeta,
	fetchCompanySection,
	parseIcoSlug,
} from "~/lib/company-profile";
import { envConfig } from "~/lib/env-validation";
import { generateMetaTags } from "~/lib/seo";
import type { Route } from "./+types/dokumenty";

export async function loader({ params }: Route.LoaderArgs) {
	const ico = parseIcoSlug(params.icoSlug);

	const documents = await fetchCompanySection<DocumentsResponse>(
		`${envConfig.apiBaseUrl}/companies/${ico}/documents`,
	);

	return { ico, documents };
}

export function meta({ data: loaderData, matches }: Route.MetaArgs) {
	const company = companyFromMatches(matches);
	if (!company) return companyNotFoundMeta();

	return generateMetaTags({
		...companySocialMeta(company),
		title: `Sbírka listin – ${company.name} | FirmIndex`,
		description: `Dokumenty ze sbírky listin firmy ${company.name} (IČO: ${company.ico}) — účetní závěrky, výroční zprávy a další listiny.`,
		canonical: companyCanonicalUrl(company, "dokumenty"),
		noindex: !loaderData?.documents || loaderData.documents.documents.length === 0,
	});
}

export default function CompanyDokumentyRoute({ loaderData }: Route.ComponentProps) {
	if (!loaderData.documents) {
		return <SectionError message="Nepodařilo se načíst dokumenty." />;
	}
	return <DocumentsTab ico={loaderData.ico} documents={loaderData.documents.documents} />;
}
